export function determineUnderlying(symbol){
  if (symbol.length < 6) return symbol;

  return symbol.split('.')[0];
}


